import { render, staticRenderFns } from "./DashboardMarketing.vue?vue&type=template&id=2a360c87&scoped=true"
import script from "./DashboardMarketing.vue?vue&type=script&lang=js"
export * from "./DashboardMarketing.vue?vue&type=script&lang=js"
import style0 from "./DashboardMarketing.vue?vue&type=style&index=0&id=2a360c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a360c87",
  null
  
)

export default component.exports